import Repository from '../../repositories/RepositoryFactory';
const auditRepository = Repository.get('audits');

export default {
	namespaced: true,
	state: {
		report: [],
		reportDetails: null,
	},
	mutations: {
		STORE_REPORT (state, payload) {
			state.report = payload;
		},
		STORE_REPORT_DETAILS (state, payload) {
			state.reportDetails = payload;
		},
	},
	actions: {
		async getAuditReport ({ commit }, body) {
			const response = await auditRepository.getReportByOrganization(body);
			commit('STORE_REPORT', response.data.staffSummaries ?? []);
		},
		async getByMedicalStaffId ({ commit }, body) {
			const response = await auditRepository.getByMedicalStaffId(body);
			commit('STORE_REPORT_DETAILS', response.data);
		},
		async getByMedicalStaffIdByHospitalId ({ commit }, body) {
			const response = await auditRepository.getByMedicalStaffIdByHospitalId(body);
			commit('STORE_REPORT_DETAILS', response.data);
		},
		async getByMedicalStaffIdByHospitalIdByPatientId ({ commit }, body) {
			const response = await auditRepository.getByMedicalStaffIdByHospitalIdByPatientId(body);
			commit('STORE_REPORT_DETAILS', response.data);
		},
	},
};
